export default function featureHardwareSupported(feature, hardwareVersion) {
    if (!feature?.hardware?.length) {
        return true
    }
    if (hardwareVersion == null) {
        return true
    }
    return feature.hardware.includes(hardwareVersion)
}

export function filterConfigurationByHardware(configuration, features, hardwareVersion) {
    if (!configuration) {
        return configuration
    }
    return Object.keys(configuration).reduce((filtered, featureName) => {
        const feature = features?.[featureName]
        if (!feature || featureHardwareSupported(feature, hardwareVersion)) {
            filtered[featureName] = configuration[featureName]
        }
        return filtered
    }, {})
}
